import { useCallback } from "react";

import { queryClient } from "../../../services/query";

import {
  featureFlagsQueryKeyPrefix,
  deleteAllLaunchDarklyInstances,
} from "./featureFlags.query";

// ##################################
// ## useInvalidateAllFeatureFlags ##
// ##################################

export type ResultOfUseInvalidateAllFeatureFlags = () => Promise<void>;
export type UseInvalidateAllFeatureFlags =
  () => ResultOfUseInvalidateAllFeatureFlags;

/**
 * Invalidates all feature flags data.
 */
export const useInvalidateAllFeatureFlags: UseInvalidateAllFeatureFlags =
  () => {
    return useCallback(async () => {
      await deleteAllLaunchDarklyInstances();
      await queryClient.invalidateQueries(featureFlagsQueryKeyPrefix);
    }, []);
  };

// #############################
// ## useClearAllFeatureFlags ##
// #############################

export type ResultOfUseClearAllFeatureFlags = () => Promise<void>;
export type UseClearAllFeatureFlags = () => ResultOfUseClearAllFeatureFlags;

/**
 * Clears and invalidates all feature flags data.
 * A fresh fetch of data will be initiated when a hook instance is active that uses this data.
 */
export const useClearAllFeatureFlags: UseClearAllFeatureFlags = () => {
  return useCallback(async () => {
    await deleteAllLaunchDarklyInstances();
    await queryClient.resetQueries(featureFlagsQueryKeyPrefix);
  }, []);
};
